<!--
  IpForm : Ipv4 Component

  @since 2017-11-10
  @author kdydesign.kim
-->

<template>
  <div class="inline-group">
    <!--TAMS HA Force 제거-->
    <q-toggle v-model="ipTypeValue"
              :true-value="ipv6Value"
              :false-value="ipv4Value"
              :disable="disable"
              @input="onChangeToggle"
              class="bs bs-q-toggle bs-q-toggle-ipv4n6"
    />

    <!--v-show 를 v-if 로 변경했습니다. maskValue 가 양쪽에 바인딩되어 오동작합니다. 관련 화면 (관리자 IP 주소 등록)-->
    <div v-if="ipTypeValue === ipv4Value" style="float:left">
      <!--TAMS HA Force 제거-->
      <ipv4 ref="ipv4Form"
            name="IPv4"
            :key="'ipV4Component'"
            :ping="ping"
            :ip.sync="ipValue"
            :disable="disable"
            :required="required && ipTypeValue === ipv4Value"
            :is-valid="ipTypeValue === ipv4Value"
            :readonly="readonly"
            :validator="validator"
            :mask.sync="maskValue"
            :mask-min-value="ipv4MaskMinValue"
            :mask-max-value="ipv4MaskMaxValue"
            :data-vv-scope="dataVvScope"
      />
    </div>

    <div v-if="ipTypeValue === ipv6Value" style="float:left">
      <!--TAMS HA Force 제거-->
      <ipv6 ref="ipv6Form"
            name="IPv6"
            :key="'ipV6Component'"
            :ping="ping"
            :ip.sync="ipValue"
            :disable="disable"
            :required="required && ipTypeValue === ipv6Value"
            :is-valid="ipTypeValue === ipv6Value"
            :readonly="readonly"
            :validator="validator"
            :prefix-min="prefixMin"
            :prefix-max="prefixMax"
            :prefix.sync="maskValue"
            :data-vv-scope="dataVvScope"
      />
    </div>
  </div>
</template>

<script>
  // IP Components
  import Ipv4 from './Ipv4'
  import Ipv6 from './Ipv6'

  const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/
  const ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/
  export default {
    name: 'IpToggle',
    components: {
      Ipv4,
      Ipv6
    },
    props: {
      // ???
      value: {
        required: true,
        type: [Number, String],
        default: 'ipv4'
      },
      // 토글별 IP 타입
      ipv4Value: {
        type: [Number, String],
        default: 'ipv4'
      },
      ipv6Value: {
        type: [Number, String],
        default: 'ipv6'
      },
      // IPv4 관련 Props
      ip: {
        type: String,
        default: ''
      },
      mask: {
        type: [Number, String],
        default: void 0
      },
      required: {
        type: Boolean,
        default: false
      },
      ipv4MaskMinValue: {
        type: Number,
        default: void 0
      },
      ipv4MaskMaxValue: {
        type: Number,
        default: void 0
      },
      // IPv6 관련 Props
      prefixMin: {
        type: Number,
        default: 1
      },
      prefixMax: {
        type: Number,
        default: 128
      },
      // 컴포넌트 관련 Props
      ping: {
        type: Boolean,
        default: false
      },
      disable: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      validator: {
        type: Object,
        default: void 0,
        validator: function (value) {
          return value
        }
      },
      dataVvScope: {
        type: String,
        default: ''
      },
      // TAMS 미사용
      haForce: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        ipTypeValue: 'ipv4',
        ipValue: '',
        maskValue: void 0
      }
    },
    created () {
      // 전달된 Validator가 없을경우 자기 자신의 Validator 객체를 전달한다.
      this.$validator = this.validator || this.$validator
    },
    mounted () {
      // 초기값 설정
      this.ipValue = this.ip || ''
      this.maskValue = this.mask || void 0
      this.ipTypeValue = this.value || this.ipv4Value
    },
    beforeDestroy () {
      // IPv4, v6 Form 값 초기화
      this.clear()
    },
    methods: {
      validate () {
        // Todo: this.$validator.validate() or verify() 정상적으로 동작하지 않는 문제가 있어 아래와 같이 작성, 추후 로직 변경
        if (this.ipTypeValue === this.ipv4Value) {
          if (ipv4Regex.test(this.ipValue)) {
            return {isIP: true, errors: []}
          } else {
            return {isIP: false, errors: [this.$t('vl.isValidIPv4')]}
          }
        } else if (this.ipTypeValue === this.ipv6Value) {
          if (ipv6Regex.test(this.ipValue)) {
            return {isIP: true, errors: []}
          } else {
            return {isIP: false, errors: [this.$t('vl.isValidIPv6')]}
          }
        }
      },
      onChangeToggle (value) {
        // 상위 컴포넌트의 input 이벤트 전달. 커스터 마이징 시 input 이벤트를 전달해야 부모 모델에 데이터가 반영됨.
        this.$emit('input', value)

        // IPv4, v6 Form 값 초기화
        this.clear()

        // 에러 초기화
        this.errors.clear()

        // Mask 값이 있는 경우 상위 컴포넌트의 mask 값 업데이트
        if (this.maskValue !== void 0) {
          this.maskValue = ''
          this.$emit('update:mask', '')
        }

        // IP값 초기화
        this.ipValue = ''

        // 상위 컴포넌트의 IP 값 업데이트
        this.$emit('update:ip', void 0)
      },
      clear () {
        if (!_.isUndefined(this.$refs.ipv4Form)) {
          this.$refs.ipv4Form.clear()
        }
        if (!_.isUndefined(this.$refs.ipv6Form)) {
          this.$refs.ipv6Form.clear()
        }
      }
    },
    watch: {
      ip (value) {
        this.ipValue = value
      },
      mask (value) {
        this.maskValue = value
      },
      value (value) {
        this.ipTypeValue = value
      },
      ipValue (value) {
        this.$emit('update:ip', value)
      },
      maskValue (value) {
        this.$emit('update:mask', value)
      }
    }
  }
</script>
